import * as React from "react";
import {translate} from 'react-i18next';
import {Accordion, Icon} from "semantic-ui-react";

// service
import {
    OptionBasicDto,
    TypefamilyDto
} from "../../services/Client";

// reducer
import {ITranslatedComponent} from "../../redux/reducers/generalReducer";

import SelectField from "../../components/SelectField";
import Button from "../../components/Button";
import Dialog from "../../components/Dialogs/Dialog";

interface ISelectInitPslDialogProps extends ITranslatedComponent {
    /** Create the new PSL based on these options basics. */
    optionBasics: OptionBasicDto[];

    /** All type families to choose from. */
    typefamilies: TypefamilyDto[];

    /** Close dialog and pass the selected copy argument. */
    onInitPsl?: (typefamilyId: number, optionBasicDtos: OptionBasicDto[]) => any;

    /** Close dialog without return value. */
    onClose?: () => any;
}

interface ISelectInitPslDialogState {
    /** Option basic details display. */
    detailsOpen: boolean;
    /** The selected type family item. */
    selectedTypefamily?: TypefamilyDto;
}

class SelectInitPslDialog extends React.Component<ISelectInitPslDialogProps, ISelectInitPslDialogState> {
    constructor(props: ISelectInitPslDialogProps) {
        super(props);

        this.state = {
            detailsOpen: false,
            selectedTypefamily: undefined,
        };
    }

    isSelectionValid = (): boolean => {
        const {selectedTypefamily} = this.state;
        return selectedTypefamily !== undefined;
    }

    onInitPsl = async () => {
        if (!this.props.onInitPsl) {
            return;
        }

        const {selectedTypefamily} = this.state;
        if (selectedTypefamily === undefined) {
            return;
        }

        this.props.onInitPsl(selectedTypefamily.objectId, this.props.optionBasics);
    }

    renderSelectionControls = (): JSX.Element => (
        <SelectField
            placeholder={this.props.t("TYPEFAMILY")}
            clearable={false}
            dataSource={this.props.typefamilies}
            value={this.state.selectedTypefamily}
            onChange={(value: TypefamilyDto) => {
                this.setState({selectedTypefamily: value});
            }}
            rendererKey={(value: TypefamilyDto) => this.props.t("GLOBAL:" + value.key)}
        />
    )

    renderOptionBasics = (): JSX.Element => (
        <div>
            <Accordion>
                <Accordion.Title
                    active={this.state.detailsOpen}
                    onClick={() => this.setState({detailsOpen: !this.state.detailsOpen})}
                >
                    <Icon name="dropdown" />
                    {this.props.optionBasics.length + " " + this.props.t("OPTION_BASIC_SELECTED")}
                </Accordion.Title>
                <Accordion.Content
                    active={this.state.detailsOpen}
                >
                    {this.props.optionBasics.map(dto => dto.optionCode || this.props.t("UNNAMED")).sort().join(", ")}
                </Accordion.Content>
            </Accordion>
        </div>
    )

    render() {
        return (
            <Dialog
                open={true}
                title={this.props.t("INIT_PSL")}
                actions={[
                    <Button
                        key={"submitButton"}
                        icon={"checkmark"}
                        disabled={!this.isSelectionValid()}
                        onClick={this.onInitPsl}
                    />,
                    <Button
                        key={"cancelButton"}
                        icon={"ban"}
                        onClick={this.props.onClose}
                    />
                ]}
            >
                {
                    this.props.typefamilies.length > 0 ?
                        <>
                            {this.renderSelectionControls()}
                            {this.renderOptionBasics()}
                        </>
                        : <>{this.props.t("MISSING_ACCESS_RIGHTS")}</>
                }
            </Dialog>
        );
    }
}

export default translate("BASEOPTIONS")(SelectInitPslDialog);



// WEBPACK FOOTER //
// ./src/views/BaseOptionsView/SelectInitPslDialog.tsx